import { Layout } from '../../common/components';
import { routes } from '../../constants/routes';
import { TrustCard } from './components';

export default function Trust() {
  return (
    <Layout>
      <p className="trust-module-heading">Welcome to Trust Module!</p>
      <div className="trust-home-cards-wrapper">
        <TrustCard
          size="sm"
          title="Trust Accounts"
          subtitle="Post Trust Accounts Creation"
          to={routes.TRUST_ACCOUNTS}
        />
        <TrustCard
          size="sm"
          title="Defaulted Trust Contracts"
          subtitle="Trust Accounts which defaulted payments."
          to={routes.TRUST_DEFAULTS}
        />
        <TrustCard
          size="sm"
          title="Closed Trust Contracts"
          subtitle="Accounts Paid in Full and Consumed in Full."
          to={routes.TRUST_CLOSED}
        />
        <TrustCard
          size="sm"
          title="Equity on Cancelled Contracts"
          subtitle="Accounts with Equity cancelled post setting up trust accounts."
          to={routes.TRUST_EQUITY}
        />
        <TrustCard
          size="sm"
          title="Trust Items Report"
          subtitle="Generates the list of trust items"
          to={routes.TRUST_ITEMS_REPORT}
        />
        <TrustCard
          size="sm"
          title="Trust Monthly Report"
          subtitle="Generate monthly report
          (Trust Item Consumption, Trust Sales Item, Endowment Care Sales)"
          to={routes.TRUST_MONTHLY_REPORT}
        />
        <TrustCard
          size="sm"
          title="Detailed Contract Allocation Report"
          subtitle="Generate Detailed Contract Allocation Report"
          to={routes.TRUST_DETAILED_REPORT}
        />
      </div>
    </Layout>
  );
}
